<template>
  <!-- 确认订单头部 -->
  <div class="order-header">
    <van-nav-bar title="确认订单" left-arrow @click-left="onClickLeft">
      <template #left>
        <van-icon name="arrow-left" color="#333333" size="24" />
      </template>
    </van-nav-bar>
    <div v-if="!showIosInpurchase">
      <section v-if="uid < 1 && isRes" class="order-detail">
        <div class="resign">
          <div class="jus-center">
            <div class="line"></div>
            <div class="resign-phone">请输入注册手机号</div>
          </div>
          <!-- <van-field v-model="userTel" autosize class="input_" type="tel" @blur="telBlur" /> -->
          <div class="phoneInfoText">此手机号将成为您的筑龙账号，请谨慎填写</div>
          <van-field v-model="userTel" autosize class="input_" placeholder="请输入手机号" type="tel" @blur="telBlur" />
          <div class="codeInpt">
            <van-field v-model="phoneCode" autosize class="input1_" placeholder="请输入验证码" type="tel"  />
            <span class="codeBtn" @click="clickCodeBtn">{{ code_text }}</span>
          </div>
          <span class="codeBtn1" @click="doneLogin">确定</span>
        </div>
        <!-- <div class="phoneInfoText">此手机号将成为您的筑龙账号，请谨慎填写</div> -->
      </section>
      <div v-if="showAddress.receiver == '请添加地址' && option.input_address" class="address_tip">
        <img src="@/assets/tip_icon.png" alt="">
        <p>订单中包含实体商品，请务必填写正确的邮寄地址。</p>
      </div>
      <!-- 地址信息 -->
      <div v-if="showAddress && option.input_address" class="address_box bgc_fff">
        <div class="address_item" @click="goAddressList">
          <div class="item_left">
            <div class="item_title">
              <span style="display: inline-block; margin-right: 20px">
                {{ showAddress.receiver }}
              </span>
              <span>{{ showAddress.mobile }}</span>
            </div>
            <div class="address_text" v-show="showAddressInfo">
              {{ completeAddress(showAddress) }}
            </div>
          </div>
          <div class="item_right" style="fontsize: 16px">
            <van-icon name="arrow" style="fontsize: 20px" />
          </div>   
        </div>
        <div v-if="nosend" class="notMailing">
          该地址暂不支持发货，请重新选择！
        </div>
        <div class="item_bottom">
          <img src="@/assets/address_bottom.png" alt srcset />
        </div>
      </div>
      <div class="bgc_fff margin_top">
        <div class="title">订单内容</div>
        <!-- 会员付费 -->
        <van-cell-group v-if="option && (this.product_type == 3 || this.product_type == 2)">
          <van-cell v-for="item in option.products" :key="item.img" is-link size="large" class="cell_box" :center="true">
            <!-- 使用 title 插槽来自定义标题 -->
            <template #title>
              <div class="jus-start">
                <div>
                  <img :src="item.img" alt class="products_img" />
                </div>
                <div class="van-multi-ellipsis--l2">{{ item.name }}</div>
              </div>
            </template>
            <template #right-icon>
              <div style="width:40PX:text-align:center">
                {{ item.price_str }}
              </div>
            </template>
          </van-cell>
        </van-cell-group>
        <van-cell-group v-else>
          <!-- <div v-if="option.products && option.products.length > 1" class="price_infos1">
            <p class="p1">定价：{{option.money.sourcePrice}}元&nbsp;&nbsp;&nbsp;&nbsp;共优惠：{{controlAllDiscount(option.money.discounts)}}元&nbsp;&nbsp;&nbsp;&nbsp;实付：{{realMoney}}元</p>
          </div> -->
          <div v-for="(item,i_index) in option.products" :key="item.img+i_index">
            <van-cell is-link size="large" class="cell_box" :center="true">
              <!-- 使用 title 插槽来自定义标题 -->
              <template #title>
                <div class="jus-start" style="align-items: flex-start">
                  <div>
                    <img :src="item.img" alt class="products_img_big" />
                  </div>
                  <div>
                    <div class="van-multi-ellipsis--l2" style="font-weight: bold;font-size:15px;line-height:22px">
                      {{ item.name }}
                    </div>
                    <!-- <div v-if="option.products && option.products.length == 1" class="price_infos">
                      <p class="p1">定价：{{option.money.sourcePrice}}元&nbsp;&nbsp;&nbsp;&nbsp;共优惠：{{controlAllDiscount(option.money.discounts)}}元</p>
                      <p class="p2">实付：{{realMoney}}元</p>
                    </div> v-else  -->
                    <!-- <div class="" v-for="(item1, index1) in item.descriptions" :key="index1" style="fontsize: 12px;margin: 4px 0;">
                      <span style="display: inline-block; margin-right: 10px ;font-size:14px; color:#F40E0E ;line-height:20px">{{
                        item1
                      }}</span>
                    </div> -->
                  </div>
                </div>
              </template>
              <template #right-icon>
              </template>
            </van-cell>
            <div v-show="product_type === '4'" class="product_bottom">
              <div class="time_text" style="font-size: 14px;color:#666" v-if="item.expire_hours">
                使用有效期至：{{ item.end_time }}
              </div>
              <div class="time_text" style="font-size: 14px;color:#666" v-else>
                <div style="fontWeight:bold">可使用时间：</div>
                <div>{{ item.start_time }}至{{ item.end_time }}</div>
              </div>
            </div>
          </div>
        </van-cell-group>
      </div>

       <!-- 赠送 -->
       <div v-if="send_list_arr && send_list_arr.length > 0" class="bgc_fff margin_top send_box" @click="selectSendPop">
        <div class="title">赠送</div>
        <div class="send_bot_box">
          <div class="send_list">
            <div v-if="select_send.length > 0" class="sel_send">
              <p>{{ selectedGiftNames(select_send) }}</p>
            </div>
            <div v-else class="no_sel_send">请选择赠品</div>
          </div>
          <div class="send_arrow">
            <van-icon name="arrow" />
          </div>
        </div>
      </div>

      <!-- 支付方式 -->
      <div class="bgc_fff margin_top">
        <div class="title">支付方式</div>
        <van-radio-group v-if="option" v-model="payType">
          <van-cell-group>
            <van-cell v-for="item in option.payTypes" :key="item.id" clickable @click="selectPayTypeFunc(item)" v-show="checkShowPayType(item)">
              <template #title>
                <div class="jus-start pay_type_box">
                  <div class="pay_img">
                    <img :src="item.pic" alt srcset />
                  </div>
                  <!-- <div class="custom-title">{{ item.name }}支付</div> -->
                </div>
              </template>
              <template #right-icon>
                <van-radio checked-color="#EE2E2E" :name="item.id" />
              </template>
            </van-cell>
          </van-cell-group>
        </van-radio-group>
        <p v-if="showAlertTips1" class="tip1" @click="clickShowTip" >若使用支付宝，请在浏览器打开</p>
      </div>
      <!-- 金额明细 -->
      <section v-if="option" class="money-detail bgc_fff margin_top">
        <p class="title">金额明细</p>
        <div class="price">
          <div class="price_item">
            <div class="price_titile">{{ option.money.name }}价格</div>
            <div class="price_text">￥{{ option.money.sourcePrice }}</div>
          </div>
          <div v-for="item in addcounts" :key="item.name" class="price_item">
            <div class="price_titile">{{ item.name }}价格</div>
            <div class="price_text">￥{{ item.price }}</div>
          </div>
          <div v-for="item in option.money.discounts" :key="item.name" class="price_item">
            <div class="price_titile">{{ item.name }}价格</div>
            <div class="price_text red_txt">-￥{{ item.price }}</div>
          </div>
        </div>
      </section>
      <!-- 支付协议 -->
      <div class="agreement_box" style>
        <van-checkbox v-model="isAgreement" shape="square" label-disabled checked-color="#EC2F2E">
          <span style="color: #333">同意</span>
          <span @click="clickAgree">支付协议</span>
        </van-checkbox>
      </div>
      <div v-if="option" class="footer">
        <p v-if="controlAllDiscount(option.money.discounts) > 0" class="price_p">
          折后价<span class="real_price">￥</span>
          <span class="real_price">{{ realMoney }}</span>
          <span class="dis_str">已优惠{{ controlAllDiscount(option.money.discounts) }}</span>
        </p>
        <p v-else class="price_p">
          应付金额<span class="real_price">￥</span>
          <span class="real_price">{{ realMoney }}</span>
        </p>
        <p class="pay_p" :style="showAddress.receiver == '请添加地址' && option.input_address ? 'background-color: #F58282' : 'background-color: #ee2e2e' " @click="pay">立即支付</p>
      </div>
    </div>
    <div v-else class="showInpurchase">
      <!-- ios 内购 -->
      <div class="title">订单内容</div>
      <!-- 会员付费 -->
      <van-cell-group>
        <van-cell :key="inP_img" is-link size="large" class="cell_box" :center="true">
          <!-- 使用 title 插槽来自定义标题 -->
          <template #title>
            <div class="jus-start">
              <div>
                <img :src="inP_img" alt class="products_img" />
              </div>
              <div class="van-multi-ellipsis--l2">{{ inP_name }}</div>
            </div>
          </template>
          <template #right-icon>
            <div style="width:40PX:text-align:center">{{ inP_price }}元/年</div>
          </template>
        </van-cell>
      </van-cell-group>
      <!-- 金额明细 -->
      <section class="money-detail bgc_fff margin_top">
        <p class="title">金额明细</p>
        <div class="price">
          <div class="price_item">
            <div class="price_titile">{{ inP_name }}价格</div>
            <div class="price_text">￥{{ inP_price }}</div>
          </div>
        </div>
      </section>
      <!-- 支付协议 -->
      <div v-if="product_type!=18" class="agreement_box" style>
        <van-checkbox v-model="isAgreement" shape="square" label-disabled checked-color="#EC2F2E">
          <span style="color: #333">同意</span>
          <span @click="clickAgree">支付协议</span>
        </van-checkbox>
      </div>
      <div class="footer">
        <p>
          应付金额
          <span class="real_price">￥</span>
          <span class="real_price">{{ inP_price }}</span>
        </p>
        <p style="color: #fff; background-color: red" @click="payIOS">
          立即支付
        </p>
      </div>
    </div>
    <div v-if="showAlertTips" class="tip_alert1" @click="showAlertTips=false">
      <img src="https://newoss.zhulong.com/forum/202503/05/49/180549h2bpasftjdqyz7no.png" alt="">
    </div>

    
    <!-- 购买弹窗 -->
    <van-popup v-model="showSendPop" round position="bottom" :style="{width:'100%',height:'70%'}" z-index="1100" :close-on-click-overlay="false">
      <div class="popup_div">
        <div class="top_title">
          <p>赠送</p>
          <div class="close_box" @click="showSendPop = false">
            <van-icon name="cross" />
          </div>
        </div>
        <div class="main_list">
          <p class="count_title">赠送{{ select_send.length }}个套装</p>
          <div class="gift_item" v-for="(gift,gidx) in send_list_arr" :key="'g'+gidx">
           <div class="left_name">
            <p class="name" @click="selectOneItem(gift)">{{ gift.lesson_name }}</p>
           </div>
           <div class="right_check">
            <van-checkbox v-model="gift.select" shape="square" label-disabled checked-color="#ee2e2e" @change="controlOneGift(gift)"></van-checkbox>
           </div>
          </div>
        </div>
        <div class="footer_box">
          <span class="done_btn" @click="showSendPop = false">确定</span>
        </div>
      </div>
    </van-popup>


  </div>
</template>
<script>
import { getPageOption, createOrder, isSuccess } from "@/api/ePayPro.js";
import { getexpensesOption } from "@/api/my_user.js";
import { EventBus } from "@/utils/event-bus.js";
import { Dialog } from "vant";
import { Toast } from "vant";
import tool from "@/utils/tools.js";
import Cookies from "js-cookie";
import WechatState from '@/utils/isWechatState.js'
import wxsdk from 'weixin-js-sdk'
import { sendMobileCode,loginByPhone, ischeckBindByuid, InsetBind } from "@/api/login.js"
import { logOut } from '@/api/login'
import { math } from '@/utils/math.js'

// Android 调用 js初始化
function connectWebViewJavascriptBridge (callback) {
  if (window.WebViewJavascriptBridge) {
    // eslint-disable-next-line no-undef
    callback(WebViewJavascriptBridge);
  } else {
    document.addEventListener(
      "WebViewJavascriptBridgeReady",
      function () {
        // eslint-disable-next-line no-undef
        callback(WebViewJavascriptBridge);
      },
      false
    );
  }
}
// 注册回调函数，第一次连接时调用 初始化函数
connectWebViewJavascriptBridge(function (bridge) {
  // 初始化
  bridge.init(function (message, responseCallback) {
    const data = {
      "Javascript Responds": "Wee!",
    };
    responseCallback(data);
  });
  // JS方法名
  bridge.registerHandler("appPaySuccess", function (data, responseCallback) {
    window.appPaySuccess(data);
    responseCallback("appPaySuccess" + data);
  });
});
export default {
  data () {
    return {
      payType:  WechatState.isWechat ? 7 : 2,
      isAgreement: true, // 支付协议
      showAddressInfo: true,
      product_type: "",
      product_id: "",
      product_num:this.$route.query.product_num||'',
      f_code: "",
      fromurl: "",
      uid: 0,
      group_id: "",
      isRes: false,
      mobile: "",

      // list: [],
      userTel: "",
      // uid:0,
      timer: null,
      showAddress: {},
      option: {
        money:{}
      },
      // 输入框状态
      isLoginStatus: true,

      // 付款数
      realMoney: 0,
      showIosInpurchase: false,
      inP_name: "VIP会员",
      inP_price: "198",
      inP_img:
        "https://newoss.zhulong.com/edu/202109/09/31/103331ubtg7csnsma9uins.png",
      webSocket: null,
      addcounts:[],
      nosend:0,
      code_text: '获取验证码',
      codeTimer: null,
      codeCount: 59,
      phoneCode: '',
      showPrice:false,
      // 提示去浏览器支付
      showAlertTips1: false,//提示文字
      showAlertTips: false, // 提示图
       // 赠送礼物数组
       send_list_arr:[],
      sfselect: false,
      select_send:[], // 选择的礼品
      showSendPop: false,
      send_type:''
    };
  },
  computed: {
    completeAddress (e) {
      return function (e) {
        return "" + e.province + e.city + e.county + e.detail_address;
      };
    },
  },

  // beforeCreate () {
  //   document
  //     .querySelector("body")
  //     .setAttribute("style", "background-color:#f7f7f7");
  // },
  created () {
    // 检测登录和授权
    this.checkLoginAndWechatBind()
    
    this.isShowPrice()
    if (tool.checkLocationAgencyId('390')) {
      let uid = parseInt(Cookies.get('uid') || '0')
      if (uid <= 0) {
        this.$router.replace('/login')
      }
    }
    // 不是小程序 引入js
    // if (!WechatState.isWechatMiniprogram) {
    //   // 创建script标签，引入外部文件
    //   const script = document.createElement('script')
    //   script.type = 'text/javascript'
    //   script.src = '/TCaptcha.js'
    //   document.getElementsByTagName('head')[0].appendChild(script)
    // }

    // socket
    if (WechatState.isWechatMiniprogram) {
      if (this.checkCanUserSocket()) {
        this.createSocket()
      }
    }
    
    // 支付方式提示
    const isWxH5 = this.checkWechatH5()
    if (isWxH5) {
      this.showAlertTips1 = true
    }

    this.getForm();
    // 上线之后 去掉ios的特殊处理
    // if (tool.isInApp()) {
    //   if (tool.isInIosApp()) {
    //     if (this.product_type === '2' || this.product_type === '3') {
    //       this.showIosInpurchase = true
    //     }
    //   }
    // }
    // if (!this.showIosInpurchase) {
    //   this.getData()
    // }

    this.getData();
  },
  mounted () {
    if (tool.isInApp()) {
      // 挂载函数，方便APP调用
      window.appPaySuccess = this.appPaySuccess;
    }
    EventBus.$on("chooseAddress", (data) => {
      this.nosend = 0 
      console.log(data);
      this.address_id = data.id;
      this.showAddress = JSON.parse(data);
      this.getMailCost()
    });
  },
  beforeDestroy () {
    sessionStorage.removeItem("chooseAddress");
    this.timer = null;
    this.closeSocket()
  },
  methods: {
    // 点击出微信h5的支付提示
    clickShowTip() {
      this.showAlertTips = true
    },
    // 检测登录和授权
    checkLoginAndWechatBind() {
      // 1、未登录 去授权
      // 2、已登录，检测是否绑定，未绑定去授权
      // 3、授权回来，判断环境，及unionid等
      // 4、由于未登录 校验登录，登录之后reload，所以就判断是否登录即可
      // 5、登录之后判断是否绑定，未绑定去绑定
      // 6、由于是去筑龙的授权，回来参数在路由里，故先取下状态存储下
      // 优先取auth_state
      const auth_state = this.$route.query.auth_state || ''
      const auth_openid = this.$route.query.auth_openid || ''
      if (auth_state == 1 && auth_openid) {
        // 存储
        const auth_unionid = this.$route.query.auth_unionid || ''
        const auth_nickname = this.$route.query.auth_nickname || ''
        localStorage.setItem('auth_openid',auth_openid)
        localStorage.setItem('auth_unionid',auth_unionid)
        localStorage.setItem('auth_nickname',auth_nickname)
        localStorage.setItem('auth_state', auth_state)
      }

      if (this.canShowAttGzh()) {
        if (Cookies.get('uid')) {
          // 已登录 检测是否绑定
          this.getNewIsbindWechatFunc()
        } else {
          // 未登录去授权，先判断是否授权过回来了
          if (localStorage.getItem('auth_state') != 1) {
            // 未授权
            this.showAuthBind()
          }
        }
      }
    },
    // 获取是否绑定过
    getNewIsbindWechatFunc() {
      ischeckBindByuid().then(res => {
        if (res.errNo == 0) {
          const result = res.result || {}
          const is_bind = result.is_bind
          if (is_bind != 1) {
            // 判断是否授权过
            if (localStorage.getItem('auth_state') == 1) { 
              // 授权过 去绑定
              this.callForBind()
            } else {
              // 没授权过 去授权
              this.showAuthBind()
            }
          } else {
            // 清理
            localStorage.removeItem('auth_state')
            localStorage.removeItem('auth_openid')
            localStorage.removeItem('auth_unionid')
            localStorage.removeItem('auth_nickname')
          }
        }
      })
    },
    // 去授权关注绑定
    showAuthBind() {
      // 回调之后回到之前的页面
      var redirect = window.location.href
      redirect = encodeURIComponent(redirect)
      const origin = 'https://m.zhulong.com'// 去筑龙授权
      var auth_redirect = `${origin}/pay/wechatAuthResult?jump_redirect=${redirect}`// 微信授权回调页面
      console.log(auth_redirect, 'auth_redirect')
      auth_redirect = encodeURIComponent(auth_redirect)
      const appid = 'wxf3117cecab674509' //this.authGzhId
      const url = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${appid}&redirect_uri=${auth_redirect}&response_type=code&scope=snsapi_userinfo&state=success#wechat_redirect`
      window.location.href = url
    },
    // 绑定接口
    callForBind() {
      const openid = localStorage.getItem('auth_openid')
      const unionid = localStorage.getItem('auth_unionid')
      const nickname = localStorage.getItem('auth_nickname')
      const query = {
        openid: openid,
        unionid: unionid,
        nickname: nickname,
      }
      InsetBind(query).then(res => {
        console.log(res,'resres')
        // 移除存储的绑定信息
        this.removeAuthCacheInfo()
        if (res.errNo == 2001) {
          // 账号问题，需要清除掉重新登陆
          this.$toast(res.msg)
          setTimeout(() => {
            this.removeLoginInfo()
          }, 2000);
        }
      })
    },
    // 移除存储的绑定信息
    removeAuthCacheInfo() {
      localStorage.removeItem('auth_state')
      localStorage.removeItem('auth_openid')
      localStorage.removeItem('auth_unionid')
      localStorage.removeItem('auth_nickname')
    },
    // 移除登录信息
    removeLoginInfo() {
      const info = {
        uuid: Cookies.get('uuid'),
        uid: Cookies.get('uid'),
        access_token: Cookies.get('access_token'),
        agency_id: Cookies.get('agency_id')
      }
      logOut(info).then(res => {
        const url = window.location.href
        window.location.href = url
      })
    },
    // 检测环境
    canShowAttGzh() {
      const isWxH5 = this.checkWechatH5()
      const agency_id = Cookies.get('agency_id')
      // const f_code = this.$route.query.f_code || ''
      // 微信h5、普通h5，即：非小程序、非app  && f_code.startsWith('RoomID')
      if (isWxH5 && agency_id == 2) {
        return true
      }
      return false
    },
    // 判断是微信h5环境
    checkWechatH5() {
      const isWxH5 = WechatState.isWechat && !WechatState.isWechatMiniprogram && !WechatState.wxwork
      return isWxH5
    },
    isShowPrice() {
      this.showPrice = new Date().getTime() < new Date('2024-10-28 00:00:00').getTime()
    },
    // 切换支付方法
    selectPayTypeFunc(i) {
      this.payType = i.id
      // if (i.id==2 && (WechatState.isWechat && !WechatState.isWechatMiniprogram)) {
      //   // 支付宝
      //   this.showAlertTips = true
      // } else {
      //   this.showAlertTips = false
      // }
    },
    // 判断显示支付方式
    checkShowPayType(i) {
      if (WechatState.isWechat) {
        if (i.id === 7) {
          return true
        } else {
          return false
        }
      } else {
        return true
      }
      // if (WechatState.isWechat) {
      //   // 微信
      //   if (WechatState.isWechatMiniprogram) {
      //     // 小程序 -- 只有微信
      //     if (i.id == 7) {
      //       return true
      //     } else {
      //       return false
      //     }
      //   } else {
      //     // 微信h5 -- 微信、支付宝
      //     if (i.id == 7 || i.id==2) {
      //       return true
      //     } else {
      //       return false
      //     }
      //   }
      // } else {
      //   return true
      // }
    },
    clickAgree () {
      var type = 1
      if (this.product_type == 2) {
        // e会员
        type = 3
      } else if (this.product_type == 3) {
        // vip
        type = 2
      }
      this.$router.push({
        path: "/agreement",
        query: { type: type },
      });
    },
    // 监听页面切换
    // 手机号输入失去焦点
    telBlur () {
      const reg = /^1[3|4|5|7|8|6|9][0-9]\d{8}$/;
      if (!reg.test(this.userTel)) {
        return Toast("手机号格式有误");
      } else {
        this.getData();
      }
    },
    // // 获取来源
    // getForm () {
    //   var url = document.URL
    //   var urlArr = url.split('?')[1].split('&')
    //   urlArr.forEach((i) => {
    //     var val = i.split('=')
    //     switch (val[0]) {
    //       case 'product_type':
    //         this.product_type = val[1]
    //         break
    //       case 'product_id':
    //         this.product_id = val[1]
    //         break
    //       case 'fromurl':
    //         this.fromurl = val[1]
    //         break
    //       case 'f_code':
    //         this.f_code = val[1]
    //         break
    //       default:
    //         break
    //     }
    //   })
    //   console.log(
    //     this.product_type,
    //     '<<<<<类型',
    //     this.product_id,
    //     '<<<<<id',
    //     this.fromurl,
    //     '<<<<<<来源',
    //     this.f_code,
    //     '<<<<<<码'
    //   )
    // },
    // 获取来源
    getForm () {
      var url = document.URL;
      var urlArr = url.split("?")[1].split("&");
      console.log(urlArr);
      urlArr.forEach((i) => {
        var val = i.split("=");
        switch (val[0]) {
          case "product_type":
            this.product_type = val[1];
            break;
          case "product_id":
            this.product_id = val[1];
            break;
          case "fromurl":
            this.fromurl = urlArr.reduce((p, i) => {
              const reduceItem = i.split("=");
              if (
                reduceItem[0] !== "product_type" &&
                reduceItem[0] !== "fromurl" &&
                reduceItem[0] !== "product_id" &&
                reduceItem[0] !== "f_code" &&
                reduceItem[0] !== "group_id"
              ) {
                return p + "&" + i;
              } else {
                return p;
              }
            }, val[1]);
            break;
          case "f_code":
            this.f_code = val[1];
            break;
          case "group_id":
            this.group_id = val[1];
            break;
          default:
            break;
        }
      });
       if (this.product_type == 2 || this.product_type == 3) {
        this.$router.replace({ path: '/buyMember', query: { product_type: this.product_type, fromurl: this.fromurl, f_code: this.f_code }})
      }
      console.log(
        this.product_type,
        "<<<<<类型",
        this.product_id,
        "<<<<<id",
        this.fromurl,
        "<<<<<<来源",
        this.f_code,
        "<<<<<<码"
      );
    },
    // 返回
    onClickLeft () {
      // 处理APP
      if (tool.isInApp()) {
        if (tool.isInIosApp()) {
          window.webkit.messageHandlers.vue_backApp.postMessage("");
        } else {
          window.WebViewJavascriptBridge.callHandler(
            "vue_backApp",
            "",
            function (responseData) {
              // android 返参数接受
            }
          );
        }
      } else {
        this.$router.go(-1);
      }
    },
    // 跳转地址列表页
    goAddressList () {
      this.$router.push({
        path: "/address/addressList",
        // query: { index: '1' }
      });
    },
    // 获取支付页面选项
    getData () {
      const dataInfo = {
        product_type: this.product_type,
        mobile: this.userTel,
        product_id: this.product_id,
        group_id: this.group_id,
      };
      // 获取支付页面选项
      getPageOption(dataInfo).then((res) => {
        if (res.errNo == 0) {
          const result = res.result || {}
          this.uid = result.uid;
          // 2025-03-05，嫌显示太多产品，去掉此判断，显示一个产品，
          // const strategyLessons = result.strategyLessons || []
          // // 区分更多的课程
          // const type = result.type || 0
          // if (type == 1) {
          //   strategyLessons.forEach(e => {
          //     e.name = e.lesson_name
          //     e.price_str = '￥' + (e.money || '0')
          //   })
          //   this.option.products = strategyLessons
          // }


          // 2025-03-25 取赠送礼品选择 strategyLessons : 类型为： 2 4 5
          const strategyLessons = result.strategyLessons || []
          const send_arr = strategyLessons.filter(e => e.type == 2 || e.type == 4 || e.type == 5)
          if (send_arr && send_arr.length > 0) {
            const send_type = send_arr[0].send_type || 1
            const sel_arr = []
            send_arr.forEach(e => {
              if (send_type == 2) {
                // 默认全选
                e.select = true
                sel_arr.push(e)
              } else {
                e.select = false
              }
            })
            this.send_type = send_type
            this.send_list_arr = JSON.parse(JSON.stringify(send_arr))
            this.select_send = JSON.parse(JSON.stringify(sel_arr))
          } else {
            this.send_list_arr = []
            this.send_type = ''
            this.select_send = []
          }
          
          // 获取真实money
          this.isRes = true;
          if (res.result.address.length) {
            this.showAddress =
              res.result.address.filter((i) => i.is_default === 1)[0] ||
              res.result.address[0];
          } else {
            this.showAddress = { receiver: "请添加地址" };
            this.showAddressInfo = false;
          }
          // 判断是否有订单号的cookies
          let order_on_cookies = false; //2021年11月01日改 支付完成后直接回调到成功页面，注释判断条件
          if (order_on_cookies) {
            this.checkOrderTimer(order_on_cookies,true)
          }

          // 默认支付方式处理
          const payTypes = result.payTypes || [];
          if (payTypes && payTypes.length > 0) {
            // 有支付方式
            if (payTypes.length === 1) {
              // 1个的时候，处理下默认的选项
              this.payType = payTypes[0].id
            } else {
              this.payType =  WechatState.isWechat ? 7 : 2
              // 容错处理，判断下是否有当前的支付方式
              const matched = payTypes.filter(e => e.id === this.payType)
              if (matched && matched.length ==  0) {
                this.payType = payTypes[0].id
              }
            }
          } else {
            // 没有付款方式
            this.payType = ''
            this.$toast('没有付款方式~')
          }

          this.option = result;

        } else {
          if (res.errNo === 201) {
            setTimeout(() => {
              window.history.back(-1);
            }, 1000);
          } else {
            // 提示
            this.$message.error(res.msg||'发生未知错误请重试！')
          }
        }
      }).then(()=>{
        this.getMailCost()
      })
    },
    // 计算所有的优惠价格
    controlAllDiscount(array) {
      var discount_str = 0
      if (array && array.length > 0) {
        array.forEach(e => {
          const price = parseFloat(e.price ||0)
          discount_str = math.add(discount_str, price)
        });
      }
      return discount_str
    },
    // 获取邮费信息
    getMailCost(){
      var info ={
        product_type: this.product_type,
        mobile: this.userTel,
        product_id: this.product_id,
        group_id: this.group_id,
        address_id:this.showAddress.id,
        product_num:this.product_num,
      }
      getexpensesOption(info).then((res)=>{
        if(res.errNo==0){
          this.addcounts = res.result.money.addcounts
          this.nosend = res.result.nosend
          this.realMoney = res.result.realMoney
        }
      })
    },
     // 展示选择 礼品 弹窗
     selectSendPop() {
      this.showSendPop = true
    },
    selectedGiftNames(arr) {
      const name_arr = arr.map(e => e.lesson_name)
      return name_arr.join('、')
    },
    // 整行点击
    selectOneItem(val) {
      val.select = !val.select
      this.controlOneGift(val)
    },
    // 选择或取消一个
    controlOneGift(val) {
      if (this.send_type == 1) {
        // 单选
        if (val.select) {
          // 选中
          this.select_send.forEach(e => {
              e.select = false
          })
          this.select_send = [val]
        } else {
          // 取消
          this.select_send = this.select_send.filter(e => e.id !== val.id)
        }
      } else {
        if (val.select) {
          // 选中
          this.select_send.push(val)
        } else {
          // 取消
          this.select_send = this.select_send.filter(e => e.id !== val.id)
        }
      }
    },
    // 检测订单的方法
    checkOrderTimer(order_sn,iscookie){
      Toast.loading({
        duration: 0,
        message: "开通中...",
        forbidClick: true,
      });
      // let second = 20;
      this.timer = setInterval(() => {
        isSuccess({ order_sn: order_sn }).then((res1) => {
          if (res1.result.isSuccess === 1) {
            if (iscookie) {
              Cookies.remove("zhulong_order");
            }
            Toast.clear();
            clearInterval(this.timer);
            this.timer = null;
            if(res1.result.order_type==6){
              location.href = location.origin + '/applyinfo?id='+res1.result.product_id
            } else{
              this.$router.push({
                path: "/paySuccess",
                query: { str: JSON.stringify(res1.result) },
              });
            }
            
          }
        });
        // second--;
        // if (second) {
        // } else {
          // clearInterval(this.timer);
          // this.timer = null;
        //   Toast("开通失败");
        //   if (iscookie) {
        //     Cookies.remove("zhulong_order");
        //   }
        // }
      }, 2000);
    },
    vPhone () {
      var reg = /^1[3|4|5|7|8|6|9][0-9]\d{8}$/;
      if (!reg.test(this.userTel)) {
        return true;
      } else {
        return false;
      }
    },
    //跳转成功页——APP使用
    jumpSuccess (order_sn) {
      console.log('成功order ',order_sn);
      // 检测订单状态
      isSuccess({ order_sn: order_sn }).then((res1) => {
        if (res1.errNo == 0) {
          const result = res1.result || {}
          result.isSuccess = 1
          this.$router.push({
            path: "/paySuccess",
            query: { str: JSON.stringify(res1.result) },
          });
        }
      });
      // let order = {
      //   order_sn: order_sn
      // }
      // this.$router.replace({ path: "./paySuccess", query: { str: JSON.stringify(order) } });
    },

    // 支付
    pay() {
      if (this.uid < 1 && this.vPhone()) {
        return Toast("手机号格式有误");
      }
      if (!this.payType) {
        return Toast("请选择支付方式");
      }
      if (!this.isAgreement) {
        return Toast("请同意支付协议");
      }
      if (this.option.input_address && !this.showAddress.id) {
        return Toast("请选择地址");
      }
      if(this.nosend){
        return Toast("该地区不在销售范围内");
      }
      if (this.send_list_arr.length > 0 && this.select_send.length == 0) {
        return Toast("请选择赠品");
      }
      const dataInfo = {
        mobile: this.userTel,
        product_type: this.product_type,
        pay_type: this.payType,
        product_id: this.product_id,
        product_num:this.product_num,
        f_code: this.f_code,
        group_id: this.group_id,
        address_id: this.option.input_address ? this.showAddress.id : "",
      };
      if (this.$route.query.platform) {
        dataInfo.platform = this.$route.query.platform;
      }
      // 将选择的礼品按照type 类型区分到三个数组里
      var send_lesson = [] // type = 2
      var send_book = [] // type = 4
      var send_gift = [] // type = 5
      this.select_send.forEach(e => {
        if (e.type == 2) {
          send_lesson.push(e.lesson_id)
        }
        if (e.type == 4) {
          send_book.push(e.lesson_id)
        }
        if (e.type == 5) {
          send_gift.push(e.lesson_id)
        }
      });
      dataInfo.send_lesson_id = send_lesson.join(',');
      dataInfo.send_book_id = send_book.join(',');
      dataInfo.send_giftbox_id = send_gift.join(',');

      if (this.realMoney > 0 && tool.isInApp()) {
        // 金额大于0 且 在app 处理APP支付放在此处
        const path =
          "mobile=" +
          this.userTel +
          "&product_type=" +
          this.product_type +
          "&pay_type=" +
          this.payType +
          "&product_id=" +
          this.product_id +
          "&f_code=" +
          this.f_code +
          "&address_id=" +
          dataInfo.address_id;
        this.goAppPay(path);
      }
      else if (this.realMoney > 0 && (this.checkCanUserSocket() && this.webSocket)) {
        // 小程序内嵌h5的支付
        this.sendCreateOrderDatas(dataInfo)
      }
      else {
        // h5 支付
        createOrder(dataInfo).then((res) => {
          if (res.result.real_money === 0) {
            // 0 元
            isSuccess({ order_sn: res.result.order_sn }).then((res1) => {
              if (res1.result.isSuccess === 1) {
                this.$router.push({
                  path: "/paySuccess",
                  query: { str: JSON.stringify(res1.result) },
                });
              }
            });
          } else {
            // 支付
            Cookies.set("zhulong_order", res.result.order_sn, {
              expires: 0.007,
            });
            this.goPay(res.result.code_url);

            //  setTimeout(()=>{
            //     Dialog.confirm({
            //   title: '提示',
            //   message: '您是否已经支付成功？',
            //   confirmButtonText: '支付完成',
            //   cancelButtonText: '未支付'
            // })
            //   .then(() => {
            //     isSuccess({ order_sn: res.result.order_sn }).then((res1) => {
            //       if (res1.result.isSuccess === 1) {
            //         this.$router.push({
            //           path: './paySuccess',
            //           query: { data: JSON.stringify(res1.result) }
            //         })
            //       } else {
            //         Dialog.alert({
            //           title: '提示',
            //           message: '您还未支付成功'

            //         }).then(() => {
            //           console.log('未支付订单页面')
            //         })
            //       }
            //     })
            //  },1000)

            // on confirm
          }
          console.log(res);
        });
      }
    },
    // 调起支付
    goPay (url) {
      window.location.href = url;
    },
    // go APP支付
    goAppPay (url) {
      if (tool.isInIosApp()) {
        window.webkit.messageHandlers.vue_payProduct.postMessage(url);
      } else {
        window.WebViewJavascriptBridge.callHandler(
          "vue_payProduct",
          url,
          function (responseData) {
            // android 返参数接受
          }
        );
      }
    },
    // 苹果内购专用
    payIOS () {
      const ids = "com.zhulong.edu.vip01";
      const type = "1";
      const str = "prod_id=" + ids + "&upgrade_type=" + type;
      window.webkit.messageHandlers.vue_payIosPay.postMessage(str);
    },
    // app call js function
    appPaySuccess: function (order) {
      this.jumpSuccess(order);
    },
    // 检测是否可以开启socket
    checkCanUserSocket() {
      if (typeof WebSocket === 'undefined') {
        return false
      }
      let uid = Cookies.get('uid')
      if (uid === undefined || uid == 0) {
        // 小程序内 强制去登录
        this.loginWithMiniWx()
        return false
      }
      let app_code = Cookies.get('app_code')
      if (WechatState.isWechatMiniprogram && app_code) {
        return true
      }
      return false
    },
    // 去小程序登录
    loginWithMiniWx() {
      if (WechatState.isWechatMiniprogram) {
        var url = ''
        url = `/pages/login/login?xcx_out=true`
        wxsdk.miniProgram.redirectTo({
          url: url
        })
      } else {
        this.$router.push({ path: '/login' })
      }
    },
    // 开启socket
    createSocket() {
      this.webSocket = new WebSocket('wss://m.zhulong.com/wss_socket/')
      this.webSocket.onopen = this.webSocketOnOpen
      this.webSocket.onmessage = this.webSocketGetMessage
      this.webSocket.onerror = this.webSocketOnError
      this.webSocket.onclose = this.webSocketClosed
    },
    // 链接
    webSocketOnOpen(res) {
      console.log('open ',res);
      // 登录
      let loginStr = this.createForSocketMessage('login',null)
      console.log('loginStr ',loginStr);
      this.socketSendDatas(loginStr)
    },
    // 收到消息
    webSocketGetMessage(res) {
      const message = JSON.parse(res.data)
      console.log('收到消息 ',message);
      switch (message.type) {
        case 'login_end':
          console.log('登录成功');
          break;
          case 'mini_productPaySuccess':
            // 小程序支付成功
            let app_code = Cookies.get('app_code')
            let get_app_code = message.app_code
            if (app_code == get_app_code) {
              let data = JSON.parse(message.data)
              this.socketPaySuccess(data)
            }
            break;
        default:
          break;
      }
    },
    // 失败
    webSocketOnError(res) {
      console.log('失败 ',res);
      this.createSocket()
    },
    // 关闭
    webSocketClosed(res){
      console.log('关闭 ',res);
      if (res.code != 1000) {
        // 非正常关闭
        this.createSocket()
      }
    },
    // 发消息
    socketSendDatas(jsonInfo) {
      this.webSocket.send(jsonInfo)
    },
    // 关闭socket
    closeSocket(){
      if(this.webSocket){
        this.webSocket.close()
        this.webSocket = null
      }
    },
    // 获取登录的字符串,info：object
    createForSocketMessage(type ,info){
      let uid = Cookies.get('uid')
      let appid = Cookies.get('app_id')
      let agency_id = Cookies.get('agency_id')
      let app_code = Cookies.get('app_code')
      let uidStr = agency_id+'_'+appid+'_'+uid+'_'+app_code
      var login = {
        type: type,
        uid: uidStr
      }
      // 自定义数据
      if (info) {
        login.data = JSON.stringify(info)
      }
      return JSON.stringify(login)
    },
    // 发下单
    sendCreateOrderDatas(query){
      console.log(query);
      // 区分哪个小程序
      let app_code = Cookies.get('app_code')
      let order = {
        type: 'mini_productOrderPay',
        app_code: app_code,
        paydata: JSON.stringify(query)
      }
      var infoStr = this.createForSocketMessage('proxy', order)
      console.log(infoStr);
      this.socketSendDatas(infoStr)
    },
    // 小程序支付成功 {odersn: "order12330303"}
    socketPaySuccess(e) {
      console.log(e);
      let order = e.odersn
      this.jumpSuccess(order)
    },
        // 验证码相关
        clickCodeBtn() {
      if (this.codeTimer) return
      // 校验 区号+手机号
      const mobile = this.userTel
      if (mobile.length == 0) return Toast('请输入手机号')

      // 出图形验证
      this.showCheckAlert(mobile)
      // if (!WechatState.isWechatMiniprogram) {
      // } else {
      //   // 不出验证
      //   this.sendYzmNoCheck()
      // }
    },
    // 滑块验证方法
    showCheckAlert(mobile) {
      const appid = '2090316930' // 腾讯云控制台中对应这个项目的 appid
      // 生成一个滑块验证码对象
      const that = this
      const captcha = new TencentCaptcha(appid, function (res) { // eslint-disable-line
        // 用户滑动结束或者关闭弹窗，腾讯返回的内容
        if (res.ret === 0) {
          // 成功，传递数据给后台进行验证
          const randstr = res.randstr || ''
          const ticket = res.ticket || ''
          that.sendMobileCodeFunc(mobile, ticket, randstr)
        } else {
          // 提示用户完成验证
        }
      })
      console.log('captcha',captcha);
      // 滑块显示
      captcha.show()
    },
    // 不验证滑块的 直接发验证码
    sendYzmNoCheck() {
      const phone = this.phone
      var params = {
        type: 1,
        mobile: phone,
        code_type: 1,
        client_id: 500
      }
      sendMobileCode(params).then((res) => {
        const errNo = res.errNo
        if (errNo === 0) {
          // 发送成功
          Toast('验证码发送成功')
          this.startTimer()
        } else {
          Toast(res.msg)
        }
      })
    },
    // 发送验证码方法
    sendMobileCodeFunc(mobile, ticket, randstr) {
      const q = {
        code_type: 1,
        mobile: mobile,
        ticket: ticket,
        randstr: randstr,
        agency_id: this.agency_id
      }
      sendMobileCode(q).then(res => {
        const errNo = res.errNo
        if (errNo === 0) {
          // 发送成功
          Toast('验证码发送成功')
          this.startTimer()
        } else {
          Toast(res.msg)
        }
      })
    },
    // 验证码倒计时
    startTimer() {
      this.timerAction()
      this.codeTimer = setInterval(this.timerAction, 1000)
    },
    // 关闭倒计时
    closeTimer() {
      clearInterval(this.codeTimer)
      this.codeTimer = null
    },
    // 倒计时方法
    timerAction() {
      let time = this.codeCount
      if (time > 0) {
        const seconds = Math.floor(time % 60)
        const title = seconds + 's'
        time -= 1
        this.codeCount = time
        this.code_text = title
      } else {
        this.closeTimer()
        this.codeCount = 59
        this.code_text = '重新获取验证码'
      }
    },
    // 确定 校验验证码
    doneLogin() {
      const mobile = this.userTel
      if (mobile.length == 0) return Toast('请输入手机号')
      const code = this.phoneCode
      if (code.length == 0) return Toast('请输入验证码')
      const info = {
        mobile: mobile,
        code: code,
        from_url: '',
        agency_id: Cookies.get('agency_id')
      }
      loginByPhone(info).then(res => {
        if (res.errNo === 0) {
          // 登录成功
          console.log(res, '登录成功')
          const url = window.location.href
          window.location.href = url
        } else {
          Toast(res.msg);
        }
      })
    },
  },
};
</script>
<style scoped lang='scss'>
.product_bottom {
  padding: 15px 30px;
}
// /deep/.van-checkbox__icon .van-icon{
//   width: 30px;
//   height: 30px;

// }
// /deep/.van-checkbox__label{
//   line-height: 30px;
// }
.jus-center {
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 40px 0;
  .line {
    background-color: #ee2e2e;
    width: 5px;
    height: 28px;
    margin-right: 20px;
  }
}
.money-detail {
  padding-bottom: 20px;
}
.products_img {
  display: block;
  max-height: 40px;
  max-width: 120px;
  margin-left: 5px;
  margin-right: 15px;
}
.products_img_big {
  display: block;
  width: 240px;
  margin-left: 5px;
  margin-right: 15px;
}
#redeviation-bs-indicator {
  display: none;
}
.real_price {
  color: #ec2f2e;
}
.agreement_box {
  // position: relative;
  // z-index: 10001;
  padding: 30px 20px;
}
.price_item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  line-height: 30px;
  color: #999;
  font-size: 24px;
  padding: 20px;
  .price_titile {
    font-size: 24px;
  }
  .red_txt {
    color: #ee2e2e;
  }
}
.pay_type_box {
  padding: 10px 0;
}
.jus-start {
  display: flex;
  justify-content: flex-start;
  align-items: center;
}
.title {
  font-family: PingFangSC-Medium;
  font-size: 26px;
  color: #222222;
  letter-spacing: 0;
  padding: 20px;
}
.pay_img {
  margin-right: 10px;
  img {
    display: block;
    // max-height: 40px;
    max-width: 160px;
  }
}
.bgc_fff {
  background-color: #fff;
}
.cell_box {
  padding: 30px 20px;
}
.address_box {
  .notMailing{
    color: #ee2e2e;
    font-size: 24px;
    text-align: left;
    font-family: SourceHanSansSC-regular;
    margin-top:8px;
    padding-left: 20px;
  }
  .item_bottom {
    margin-top: 20px;
    img {
      display: block;
      width: 100%;
      max-height: 2.2px;
      // height: 2px;
    }
  }
  .address_text {
    font-family: PingFangSC-Regular;
    font-size: 26px;
    color: #999999;
    letter-spacing: 0;
  }
  .address_item {
    padding: 20px 20px 0 20px;
    background-color: #fff;
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 24px;
  }
  .item_left {
    flex: 1;
  }
  .item_title {
    font-family: PingFangSC-Medium;
    font-size: 26px;
    color: #333;
    letter-spacing: 0;
    margin-bottom: 10px;
  }
  .item_right {
    width: 30px;
  }
}
.margin_top {
  margin-top: 30px;
}
.phoneInfoText {
  font-size: 24px;
  color: #999;
  line-height: 30px;
  text-align: center;
  padding: 30px 0;
}
.input_ {
  width: 60%;
  margin: 0 auto;
}
.input1_ {
  width: 40%;
}
.codeInpt {
  margin: 30px auto 0;
  display: flex;
  margin-left: 20%;
}
.codeBtn {
  display: inline-block;
  margin-left: 20px;
  font-size: 30px;
  // min-width: 220px;
  line-height: 80px;
  text-align: left;
  color: #ee2e2e;
}
.codeBtn1 {
  display: inline-block;
  width: 60%;
  height: 70px;
  border-radius: 35px;
  line-height: 70px;
  margin: 20px auto;
  font-size: 30px;
  background-color: #EE2E2E;
  color: #fff;
}

.order-header {
  background-color: #f7f7f7;
  overflow-x: hidden;
  padding-bottom: 100px;
  height: calc(100% - 100px);
  position: relative;
  z-index: 0;
  font-size: 24px;
  .order-detail {
    background-color: #f7f7f7;
    min-height: 284px;
    .resign {
      text-align: center;
      .resign-phone {
        position: relative;
        font-size: 24px;
      }
      input {
        width: 284px;
        height: 82px;
        border-radius: 2px;
        margin-top: 32px;
      }
    }
  }
  // 订单内容
  .paylist {
    background: #fff;
    img {
      width: 130px;
      display: block;
    }
  }
  .mobile {
    width: 100%;
    box-sizing: border-box;
    h2 {
      width: 240px;
      margin: 77px auto 28px;
      font-size: 30px;
      font-weight: 600;
      display: flex;
      align-items: center;
      span {
        width: 5px;
        height: 29px;
        background: #ee2d2e;
        display: inline-block;
        margin-right: 15px;
        margin-left: 10px;
      }
    }
    // 输入区域
    .number {
      width: 696px;
      height: 88px;
      margin-left: 28px;
      background: #fff;
      border-radius: 10px;
      border: 2px solid #eee;
      margin-bottom: 34px;
      display: flex;
      align-items: center;
      font-size: 30px;
      .num-left {
        width: 160px;
        text-align: center;
        border-right: 2px solid #eee;
        span {
          display: inline-block;
          font-size: 20px;
          transform: scale(0.8) scaleX(2);
        }
      }
      .num-right {
        width: 100%;
        padding-left: 25px;
        box-sizing: border-box;
      }
    }
  }
  // 优惠
  .youhui {
    width: 100%;
    background: #fff;
    margin-bottom: 22px;
    li {
      font-size: 28px;
      padding: 28px 28px 28px 26px;
      border-bottom: 2px solid #eee;
      display: flex;
      box-sizing: border-box;
      img {
        width: 40px;
        margin-right: 32px;
      }
      .first {
        width: 499px;
      }
      .second {
        span {
          color: #f02e2f;
        }
      }
    }
  }
  //
  .pay {
    ul {
      li {
        margin-bottom: 50px;
      }
    }
  }
  .time_text {
    font-size: 12px;
  }
  // 协议
  .xieyi {
    width: 100%;
    padding: 50px;
    position: relative;
    background-color: #eee;
    .ipt {
      width: 32px;
      height: 32px;
      vertical-align: middle;
    }
    span {
      color: #dab38c;
      font-size: 22px;
      display: inline-block;
      margin-left: 9px;
      vertical-align: middle;
    }
    .ipt + label {
      display: block;
      cursor: pointer;
      position: absolute;
      top: -2px;
      left: 24px;
    }
    .ipt:checked + label::before {
      display: block;
      content: "\2714";
      text-align: center;
      width: 36px;
      height: 36px;
      font-size: 24px;
      border-radius: 8px;
      color: white;
      background: rgba(240, 84, 77, 1);
    }
  }
  // 底部
  .footer {
    width: 100%;
    height: 128px;
    background: #fff;
    padding: 0 28px 28px 28px;
    box-sizing: border-box;
    display: flex;
    justify-content: space-between;
    align-items: center;
    position: fixed;
    font-size: 14px;
    z-index: 999;
    // z-index: 10;
    bottom: 0px;
    .price_p {
      color: #333;
      font-size: 24px;
      .real_price {
        color: #ee2d2e;
        font-size: 38px;
      }
      .dis_str {
        margin-left: 10px;
        font-size: 24px;
      }
    }
    .pay_p {
      position: relative;
      right: -28px;
      height: 99px;
      width: 220px;
      // background: @base-bg-color;
      // background: #ee2e2e;
      color: #fff;
      text-align: center;
      line-height: 100px;
      font-size: 28px;
    }
  }
}
/deep/.van-checkbox__label {
  color: #ca9a69;
  font-size: 28px;
  height: 52px;
  line-height: 52px;
}
.address_tip{
  padding: 9px 34px;
  height: 54px;
  background: rgba(238,46,46,0.10);
  display: flex;
  align-items: center;
  p{
    font-size: 24px;
    color: #EE2E2E;
    letter-spacing: 0;
    font-weight: 400;
  }
  img{
    width: 34px;
    height: 34px;
    margin-right: 10px;
  }
}
.tip1 {
  padding: 30px 20px;
  color: #999;
  font-size: 26px !important;
}
.tip_alert1 {
  padding: 10px 20px;
  position: fixed;
  left: 0;
  top: 0;
  right: 0;
  z-index: 9999;
  img {
    width: 100%;
    display: block;
  }
}
.send_box {
  .send_bot_box {
    padding: 5px 20px 30px;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
  }
  .no_sel_send {
    color: #ee2e2e;
    font-size: 24px;
    text-align: left; 
    font-weight: 600;
  }
  .sel_send {
    p {
      color: #333;
      font-size: 24px;
      line-height: 30px;
    }
  }
}
.popup_div {
  width: 100%;
  height: 100%;
  position: relative;
  background-color: #fff;
  .top_title {
    height: 100px;
    box-sizing: border-box;
    padding: 30px 30px;
    position: relative;
    border-bottom: 1px solid #eee;
    p {
      text-align: center;
      font-size: 32px;
    }
    .close_box {
      position: absolute;
      top: 28px;
      right: 30px;
      font-size: 30px;
      padding: 2px 4px;
    }
  }
  .main_list {
    height: calc(100% - 210px);
    box-sizing: border-box;
    padding: 30px 30px;
    overflow-y: auto;
    .count_title {
      font-size: 30px;
      font-weight: 600;
      color: #333;
    }
    .gift_item {
      padding: 20px 0;
      border-bottom: 1px solid #eee;
      display: flex;
      align-items: center;
      justify-content: space-between;
      .left_name {
        width:calc(100% - 60px);
        .name {
          color: #333;
          font-size: 24px;
          line-height: 30px;
        }
      }
      .right_check {
        width: 60px;
        display: flex;
        align-items: center;
        justify-content: center;
      }
    }
  }
  .footer_box {
    border-top: 1px solid #eee;
    box-sizing: border-box;
    width: 100%;
    height: 100px;
    position: fixed;
    left: 0;
    right: 0;
    bottom: 0;
    .done_btn {
      width: calc(100% - 60px);
      margin: 15px 30px;
      height: 70px;
      line-height: 70px;
      display: inline-block;
      text-align: center;
      background-color: #ee2e2e;
      border-radius: 40px;
      color: #fff;
      font-size: 28px;
    }
  }
}
.price_infos {
  padding: 10px;
  margin-top: 10px;
  font-size: 26px;
  line-height: 45px;
  font-weight: 600;
  .p1 {
    color: #ee2e2e;
  }
  .p2 {
    color: #ee2e2e;
  }
}
.price_infos1 {
  padding: 25px;
  margin-top: 10px;
  font-size: 26px;
  line-height: 45px;
  font-weight: 600;
  border-bottom: 1px solid #ebedf0;
  .p1 {
    color: #ee2e2e;
  }
}
</style>
